import SlimCropper, { ISlimData } from './SlimCropper';
import Slim from 'slim';

type ISlim = Slim;

export { ISlimData, ISlim };
export default SlimCropper;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SlimCropper/index.ts